<template>
  <b-container class="page_tarifs">
    <h1 class="titre">Nos grilles tarifaires</h1>

    <div class="div_lien_grille_tarifaire">
      <a class="lien_grille_tarifaire" target="_blank"
         href="https://drive.google.com/file/d/1OiBzeMNkMHGTdjtCf6zza7fpT3ahoKMd/view">
        <b-btn class="grille_tarifaire">Consulter nos tarifs</b-btn>
      </a>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'Tarifs'
  }
</script>

<style lang="scss">
@import "src/sass/app";

html {
  scroll-behavior: smooth;
}

.page_tarifs {
  margin-top: 3rem;

  .titre {
    text-align: center;
    font-family: $titlefont;
    color: $firstcolor;
    font-size: 50px;
    font-weight: bold;
    margin-bottom: 3rem;
  }

  .div_lien_grille_tarifaire {
    display: flex;
    margin: 2rem 0;
    .lien_grille_tarifaire {
      margin: auto;
      .grille_tarifaire {
        font-size: 25px;
        text-transform: uppercase;
        padding: 2rem;
        background-color: white;
        color: $firstcolor;
        border: 2px solid $firstcolor;
      }
      .grille_tarifaire:hover {
        background-color: $firstcolor;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Tarifs.vue